import { render, staticRenderFns } from "./table-2.vue?vue&type=template&id=82f56b02&scoped=true"
import script from "./table-2.vue?vue&type=script&lang=js"
export * from "./table-2.vue?vue&type=script&lang=js"
import style0 from "./table-2.vue?vue&type=style&index=0&id=82f56b02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f56b02",
  null
  
)

export default component.exports